<template>
    <main>
        <img src="../assets/images/building.png" alt="">
    </main>
</template>
<style lang="less" scoped>
main {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
}

@media screen and (max-width: 1360px) {
    main img {
        width: 100%;
    }

}
</style>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    },
}
</script>